import { useEffect } from 'react'

type Props = {
  dataAdSlot?: string
}

export const AdSense = ({ dataAdSlot }: Props) => {
  useEffect(() => {
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ;((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({})
    } catch (error) {
      console.error(error)
    }
  }, [])

  return (
    <>
      <ins
        className='adsense'
        style={{ display: 'block' }}
        data-ad-client='ca-pub-4520259680206314'
        data-ad-slot={dataAdSlot}
        data-ad-format='auto'
        data-full-width-responsive='true'
      ></ins>
    </>
  )
}
